// Net constants
export const POWER = 'Power',
  SIGNAL = 'Signal',
  NONET = 'NONET';

// Pin polygon
export const CIRCLE = 'Circle',
  POLYGON = 'Polygon',
  SQUARE = 'Square',
  RECTCORNER = 'RectCutCorner',
  RECT = 'Rectangle';